export default {
  user: {},
  token: ""
};
